module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#arrow",
      toString: function () {
        return this.url;
      }
    }